const selectors$A = {
	slide: '[data-slide]',
	slider: '[data-slider]',
};

const attributes$m = {
	slide: 'data-slide',
	stop: 'data-stop',
	style: 'style',
	targetReferrer: 'data-target-referrer',
};

class AnnouncementBar extends HTMLElement {
	constructor() {
		super();

		this.locationPath = location.href;

		this.slides = this.querySelectorAll(selectors$A.slide);
		this.slider = this.querySelector(selectors$A.slider);
		this.enableSlider = isDesktop();
		this.initSliderEvent = (event) => this.initSlider(event);
	}

	connectedCallback() {
		this.removeAnnouncement();

		if (this.slider) {
			this.initSliders();
		}

		this.addEventListener('theme:block:select', (e) => {
			this.onBlockSelect(e);
		});

		this.addEventListener('theme:block:deselect', (e) => {
			this.onBlockDeselect(e);
		});

		document.dispatchEvent(new CustomEvent('theme:announcement:init', { bubbles: true }));
	}

	/**
	 * Delete announcement which has a target referrer attribute and it is not contained in page URL
	 */
	removeAnnouncement() {
		for (let index = 0; index < this.slides.length; index++) {
			const element = this.slides[index];

			if (!element.hasAttribute(attributes$m.targetReferrer)) {
				continue;
			}

			if (this.locationPath.indexOf(element.getAttribute(attributes$m.targetReferrer)) === -1 && !window.Shopify.designMode) {
				element.parentNode.removeChild(element);
			}
		}
	}

	/**
	 * Init slider
	 */
	initSliders() {
		this.initSlider();
		document.addEventListener('theme:resize:width', this.initSliderEvent);

		this.addEventListener('theme:slider:loaded', () => {
			this.querySelectorAll(selectors$A.tickerBar)?.forEach((ticker) => {
				ticker.dispatchEvent(new CustomEvent('theme:ticker:refresh'));
			});
		});
	}

	initSlider() {
		const isDesktopView = isDesktop();
		const isMobileView = !isDesktopView;

		if ((isDesktopView && this.enableSlider) || (isMobileView && !this.enableSlider)) {
			this.slider.flkty?.destroy();

			if (isDesktopView && this.enableSlider) {
				this.enableSlider = false;
			} else if (isMobileView && !this.enableSlider) {
				this.enableSlider = true;
			}

			this.slider = new Slider(this, this.querySelector(selectors$A.slider));
			this.slider.flkty?.reposition();
		}
	}

	onBlockSelect(e) {
		if (this.slider) {
			this.slider.onBlockSelect(e);
		}
	}

	onBlockDeselect(e) {
		if (this.slider) {
			this.slider.onBlockDeselect(e);
		} else {
			this.toggleTicker(e, false);
		}
	}

	disconnectedCallback() {
		document.removeEventListener('theme:resize:width', this.initSliderEvent);
		document.removeEventListener('theme:resize:width', this.tickerResizeEvent);
	}
}

if (!customElements.get('announcement-bar')) {
	customElements.define('announcement-bar', AnnouncementBar);
}


const selectors$B = {
	frame: '[data-ticker-frame]',
	scale: '[data-ticker-scale]',
	text: '[data-ticker-text]',
	clone: 'data-clone',
};

const attributes$n = {
	autoplay: 'autoplay',
	speed: 'speed',
};

const classes$s = {
	animation: 'ticker--animated',
	unloaded: 'ticker--unloaded',
	comparitor: 'ticker__comparitor',
};

const settings$2 = {
	speed: 1.63, // 100px going to move for 1.63s
	space: 100, // 100px
};

class Ticker extends HTMLElement {
	constructor() {
		super();

		this.autoplay = this.hasAttribute(attributes$n.autoplay);
		this.scale = this.querySelector(selectors$B.scale);
		this.text = this.querySelector(selectors$B.text);
		this.speed = this.hasAttribute(attributes$n.speed) ? this.getAttribute(attributes$n.speed) : settings$2.speed;
		this.comparitor = this.text.cloneNode(true);
		this.comparitor.classList.add(classes$s.comparitor);
		this.appendChild(this.comparitor);
		this.scale.classList.remove(classes$s.unloaded);
		this.checkWidthEvent = this.checkWidth.bind(this);
	}

	connectedCallback() {
		this.checkWidth();
		this.addEventListener('theme:ticker:refresh', this.checkWidthEvent);

		document.addEventListener('theme:resize:width', this.checkWidthEvent);
	}

	disconnectedCallback() {
		document.removeEventListener('theme:resize:width', this.checkWidthEvent);
	}

	checkWidth() {
		const padding = window.getComputedStyle(this).paddingLeft.replace('px', '') * 2;

		if (this.clientWidth - padding < this.comparitor.clientWidth || this.autoplay) {
			this.text.classList.add(classes$s.animation);
			if (this.scale.childElementCount === 1) {
				this.clone = this.text.cloneNode(true);
				this.clone.setAttribute(selectors$B.clone, '');
				this.scale.appendChild(this.clone);

				if (this.autoplay) {
					for (let index = 0; index < 10; index++) {
						const cloneSecond = this.text.cloneNode(true);
						cloneSecond.setAttribute(selectors$B.clone, '');
						this.scale.appendChild(cloneSecond);
					}
				}

				const animationTimeFrame = ((this.text.clientWidth / settings$2.space) * Number(this.speed)).toFixed(2);

				this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`);
			}
		} else {
			this.text.classList.add(classes$s.animation);
			let clone = this.scale.querySelector(`[${selectors$B.clone}]`);
			if (clone) {
				this.scale.removeChild(clone);
			}
			this.text.classList.remove(classes$s.animation);
		}
	}
}

if (!customElements.get('ticker-bar')) {
	customElements.define('ticker-bar', Ticker);
}